export default function(request, reject, rootAddress) {
  var service = {};
  /**
		获取活动配置
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/team260804/get_config?entry_source=sms_share&share_code=bd519c9baff29298079044d52e4606e7

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "account": "159***520",
	        "share_code": "bd519c9baff29298079044d52e4606e7",
	        "get_prize_status": 1,
	        "activity_status": 1,
	        "player_type": 1,
	        "team_status": 1,
	        "review_status": 0,
	        "has_share_prize": 0,
	        "session_id": "G7lbC3TORB705BQMUYltWucLXqBoujLtkcQUil3n",
	        "request_id": "bcb7727c39a29cf8599d90a0eef657acaacf6637"
	    }
	 }
		*/
  service.getConfig = function(_mock_passport_account, entry_source, from_team_id, share_code) {
    return request
      .jsonp(rootAddress + '/jxsjmobile4/team260804/get_config', {
        _mock_passport_account: _mock_passport_account /*  通行证（模拟登录，测试环境使用） */,
        entry_source: entry_source /*  进入来源（sms_share：短信分享，team_share：队伍海报分享，direct或不传：直接进入） */,
        from_team_id: from_team_id /*  来源队伍ID（entry_source=team_share时记录） */,
        share_code: share_code /*  分享人个人分享码（携带时用于回流识别，分享人记录到其inviter_account） */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": {
            "account": "脱敏通行证（未登录返回空字符串）",
            "activity_status": "活动阶段（0：未开始，1：进行中，2：已结束）",
            "get_prize_status": "领奖时间状态（0：未开始，1：进行中，2：已结束）",
            "has_share_prize": "是否已触发首次分享海报奖励（0：否，1：是）",
            "player_type": "玩家身份（0：未判断，1：新玩家，2：老玩家）",
            "review_status": "回顾状态（0：未完成，1：已完成）",
            "share_code": "个人分享码（用于生成海报/邀请链接及回流识别，未登录返回空字符串）",
            "team_status": "队伍状态（0：无队伍，1：已有队伍）"
          }
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20102",
        "description": "领奖时间配置缺失"
      }, {
        "code": "-20103",
        "description": "领奖未开启"
      }, {
        "code": "-20104",
        "description": "领奖已结束"
      }]
      		*/
        return reject(response);
      });
  };
  /**
		奖励列表
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/team260804/get_prize_list?_mock_passport_account=13380802460

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "prize_list": [
	            {
	                "prize_id": "share_poster",
	                "claim_status": 0
	            }
	        ],
	        "prize_time": 1,
	        "bind_role": [],
	        "session_id": "G7lbC3TORB705BQMUYltWucLXqBoujLtkcQUil3n",
	        "request_id": "75da7292dc8a888f546e73b154e975376c27e583"
	    }
	 }
		*/
  service.getPrizeList = function(_mock_passport_account) {
    return request
      .jsonp(rootAddress + '/jxsjmobile4/team260804/get_prize_list', {
        _mock_passport_account: _mock_passport_account /*  通行证（模拟登录，测试环境使用） */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": {
            "bind_role": "已绑定角色信息",
            "prize_list": "奖励列表",
            "prize_time": "领奖时间状态（0：未到领奖时间，1：可领奖，2：已过领奖时间）"
          },
          "data{}.prize_list[]": {
            "claim_status": "领奖状态（0：不可领奖，1：可领奖，2：已领奖）",
            "prize_id": "奖励标识（share_poster：首次海报奖励）"
          }
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20102",
        "description": "领奖时间配置缺失"
      }, {
        "code": "-20103",
        "description": "领奖未开启"
      }, {
        "code": "-20104",
        "description": "领奖已结束"
      }]
      		*/
        return reject(response);
      });
  };
  /**
		领取奖励
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/team260804/claim_prize?_mock_passport_account=13380802460&prize_id=share_poster

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "KZYPUIN5lVxQ0o5EbtSzomOiWlSdC5srykqwybkx",
	        "request_id": "6870aa6de2749d8be7da80e4a2af4e52aefc8689"
	    }
	 }
		*/
  service.claimPrize = function(_mock_passport_account, prize_id) {
    return request
      .jsonp(rootAddress + '/jxsjmobile4/team260804/claim_prize', {
        _mock_passport_account: _mock_passport_account /*  通行证（模拟登录，测试环境使用） */,
        prize_id: prize_id /*  奖励标识 */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": []
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20102",
        "description": "领奖时间配置缺失"
      }, {
        "code": "-20103",
        "description": "领奖未开启"
      }, {
        "code": "-20104",
        "description": "领奖已结束"
      }, {
        "code": "-20122",
        "description": "请先绑定角色"
      }, {
        "code": "-20133",
        "description": "奖励不存在"
      }, {
        "code": "-20134",
        "description": "奖励已领取"
      }, {
        "code": "-20135",
        "description": "未满足领取条件"
      }]
      		*/
        return reject(response);
      });
  };
  /**
		队伍信息
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/team260804/team_config

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "team_id": "76ab6c06bcf144cb378f77c8e06fd1c1",
	        "team_members": [
	            {
	                "nickname": "1517",
	                "num": 3
	            },
	            {
	                "nickname": "1519",
	                "num": 1
	            },
	            {
	                "nickname": "1518",
	                "num": 2
	            }
	        ],
	        "team_status": 0,
	        "is_nickname_modified": 1,
	        "session_id": "eRkqA33l147U08zgnAYiqAqWdK826VaGgELa8UKS",
	        "request_id": "c479952afca851ce3842b48d55ed64db6ebe6316"
	    }
	 }
		*/
  service.teamConfig = function() {
    return request.jsonp(rootAddress + '/jxsjmobile4/team260804/team_config', {}).then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
        {
          "data{}": {
            "is_nickname_modified": "是否已修改昵称（0：未修改，1：已修改）",
            "team_id": "队伍id",
            "team_members": "队伍成员",
            "team_status": "组队时间状态（0：未开始，1：进行中，2：已结束）"
          },
          "data{}.team_members[]": {
            "nickname": "昵称",
            "num": "头像编号"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20105",
        "description": "组队时间未配置"
      }, {
        "code": "-20108",
        "description": "组队时间未开始"
      }, {
        "code": "-20109",
        "description": "组队时间已结束"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		队伍信息（客态）
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/team260804/get_team_info_by_id?_mock_passport_account=12231233333&team_id=b790de71dddbd2c2cfc0a02693f6def6&share_code=bd519c9baff29298079044d52e4606e7

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "team_id": "76ab6c06bcf144cb378f77c8e06fd1c1",
	        "team_members": [
	            {
	                "nickname": "1517",
	                "num": 1,
	                "is_self": 0,
	                "is_inviter": 1
	            }
	        ],
	        "member_count": 1,
	        "is_full": 0,
	        "team_status": 1,
	        "session_id": "eRkqA33l147U08zgnAYiqAqWdK826VaGgELa8UKS",
	        "request_id": "c479952afca851ce3842b48d55ed64db6ebe6316"
	    }
	 }
		*/
  service.getTeamInfoById = function(_mock_passport_account, share_code, team_id) {
    return request
      .jsonp(rootAddress + '/jxsjmobile4/team260804/get_team_info_by_id', {
        _mock_passport_account: _mock_passport_account /*  通行证（模拟登录，测试环境使用） */,
        share_code: share_code /*  分享人个人分享码（邀请链接携带，用于标记邀请人） */,
        team_id: team_id /*  队伍id（邀请链接携带） */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": {
            "is_full": "队伍是否已满（0：未满，1：已满）",
            "member_count": "当前成员数",
            "team_id": "队伍id",
            "team_members": "队伍成员",
            "team_status": "组队时间状态（0：未开始，1：进行中，2：已结束）"
          },
          "data{}.team_members[]": {
            "is_inviter": "是否为邀请人（0：否，1：是；携带share_code且分享人在队伍中时对应成员为1）",
            "is_self": "是否本人（0：否，1：是）",
            "nickname": "昵称",
            "num": "头像编号"
          }
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20105",
        "description": "组队时间未配置"
      }, {
        "code": "-20108",
        "description": "组队时间未开始"
      }, {
        "code": "-20109",
        "description": "组队时间已结束"
      }, {
        "code": "-20125",
        "description": "请输入正确的队伍邀请码"
      }]
      		*/
        return reject(response);
      });
  };
  /**
		创建队伍
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/team260804/create_team?_mock_passport_account=13380802460

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "team_id": "76ab6c06bcf144cb378f77c8e06fd1c1",
	        "next": "poster",
	        "session_id": "eRkqA33l147U08zgnAYiqAqWdK826VaGgELa8UKS",
	        "request_id": "2a72fd8961ee0d6336bc87153806bc9fd49cef74"
	    }
	 }
		*/
  service.createTeam = function(_mock_passport_account) {
    return request
      .jsonp(rootAddress + '/jxsjmobile4/team260804/create_team', {
        _mock_passport_account: _mock_passport_account /*  通行证（模拟登录，测试环境使用） */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": {
            "next": "下一步建议（poster=生成海报，recall_list=好友召回列表）",
            "team_id": "队伍id"
          }
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20105",
        "description": "组队时间未配置"
      }, {
        "code": "-20108",
        "description": "组队时间未开始"
      }, {
        "code": "-20109",
        "description": "组队时间已结束"
      }, {
        "code": "-20124",
        "description": "当前账号已有队伍"
      }]
      		*/
        return reject(response);
      });
  };
  /**
		加入队伍
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/team260804/join_team?_mock_passport_account=13380802460&team_id=fe5422009c961d44574827688b4b8a22

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "eRkqA33l147U08zgnAYiqAqWdK826VaGgELa8UKS",
	        "request_id": "7861b2e12c699a30eff1ae145e64cb1dda3edd54"
	    }
	 }
		*/
  service.joinTeam = function(_mock_passport_account, team_id) {
    return request
      .jsonp(rootAddress + '/jxsjmobile4/team260804/join_team', {
        _mock_passport_account: _mock_passport_account /*  通行证（模拟登录，测试环境使用） */,
        team_id: team_id /*  队伍id */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": []
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20105",
        "description": "组队时间未配置"
      }, {
        "code": "-20108",
        "description": "组队时间未开始"
      }, {
        "code": "-20109",
        "description": "组队时间已结束"
      }, {
        "code": "-20124",
        "description": "当前账号已有队伍"
      }, {
        "code": "-20125",
        "description": "请输入正确的队伍邀请码"
      }, {
        "code": "-20126",
        "description": "该队伍成员已达到上限"
      }]
      		*/
        return reject(response);
      });
  };
  /**
		修改队伍信息
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/team260804/update_member_msg?_mock_passport_account=13380802460&nickname=玩家0880

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "b8SrwZ721EV71j85eGaDHZ4Et4eBivX9e6PQDk7z",
	        "request_id": "9b854d7dc6c50edf2a0bfc40a673fe7a23e2be0a"
	    }
	 }
		*/
  service.updateMemberMsg = function(_mock_passport_account, nickname) {
    return request
      .jsonp(rootAddress + '/jxsjmobile4/team260804/update_member_msg', {
        _mock_passport_account: _mock_passport_account /*  通行证（模拟登录，测试环境使用） */,
        nickname: nickname /*  昵称 */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": []
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20105",
        "description": "组队时间未配置"
      }, {
        "code": "-20108",
        "description": "组队时间未开始"
      }, {
        "code": "-20109",
        "description": "组队时间已结束"
      }, {
        "code": "-20129",
        "description": "该账号未组队"
      }, {
        "code": "-20130",
        "description": "请输入修改的昵称"
      }, {
        "code": "-20131",
        "description": "昵称含有敏感词汇，请修改后重新提交！"
      }, {
        "code": "-20137",
        "description": "昵称只能修改一次"
      }, {
        "code": "-20138",
        "description": "昵称最多8个字符"
      }]
      		*/
        return reject(response);
      });
  };
  /**
		绑定角色
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/team260804/bind_role?_mock_passport_account=12231233333&server=一区&server_id=s1&role_id=r12345&role=玩家0880

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "b8SrwZ721EV71j85eGaDHZ4Et4eBivX9e6PQDk7z",
	        "request_id": "9b854d7dc6c50edf2a0bfc40a673fe7a23e2be0a"
	    }
	 }
		*/
  service.bindRole = function(_mock_passport_account, role, role_id, server, server_id) {
    return request
      .jsonp(rootAddress + '/jxsjmobile4/team260804/bind_role', {
        _mock_passport_account: _mock_passport_account /*  通行证（模拟登录，测试环境使用） */,
        role: role /*  角色昵称 */,
        role_id: role_id /*  角色ID */,
        server: server /*  服务器名 */,
        server_id: server_id /*  服务器ID */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": []
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20118",
        "description": "请选择服"
      }, {
        "code": "-20119",
        "description": "请选择角色"
      }, {
        "code": "-20132",
        "description": "该账号已绑定角色"
      }, {
        "code": "-20149",
        "description": "该服已绑定该角色"
      }]
      		*/
        return reject(response);
      });
  };
  /**
		老玩家回顾数据
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/team260804/get_review?_mock_passport_account=12231233333

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "review_data": {
	            "account_id": "10002368",
	            "first_login_date": "2023-08-15",
	            "role_id": "c80001236",
	            "role_name": "孤影残阳",
	            "role_level": 95,
	            "role_online_time": 215400,
	            "role_menpai_id": "3",
	            "role_menpai_name": "武当",
	            "role_body_type": "1",
	            "role_gender": "男",
	            "hengdaoshu_cnt": 126,
	            "hengdaoshu_time": 4320,
	            "songjin_cnt": 233,
	            "baihutang_cnt": 88,
	            "tong_id": "t50021",
	            "tong_name": "烟雨阁",
	            "tong_days": 426,
	            "lingtu_cnt": 2,
	            "tianxia_cnt": 1,
	            "linan_cnt": 3,
	            "is_zuzhang": 0,
	            "is_fuzuzhang": 1,
	            "is_zhanglao": 1,
	            "is_baobei": 0,
	            "tong_position_list": "副族长,长老",
	            "fudai_cnt": 20800,
	            "p2p_cnt": 56,
	            "baitan_yuanbao": 128000,
	            "baitan_cuiyu": 5600,
	            "jianxia_score": 9688,
	            "first_hit_count": 4,
	            "last_hit_count": 7,
	            "partner_date": "2024-02-14",
	            "partner_name": "月下听雪",
	            "master_date": "2023-09-01",
	            "master_name": "一剑霜寒",
	            "disciple_names": ["青衫客", "白衣渡", "醉清风"],
	            "tag_list": {
	                "3": [
	                    { "name": "风流才子", "desc": "曾结交≥2个情缘" },
	                    { "name": "桃李满天下", "desc": "≥5位徒弟成功出师" },
	                    { "name": "外观收藏家", "desc": "历史曾经激活20个以上外观" }
	                ],
	                "2": [
	                    { "name": "胜友如云", "desc": "社交好友数量≥100个" },
	                    { "name": "百战不屈", "desc": "死亡记录≥1000次" },
	                    { "name": "凌绝顶", "desc": "历史自然月末排名战力榜前10" }
	                ],
	                "1": [
	                    { "name": "家族脊梁", "desc": "曾经担任过普通成员外的职位" },
	                    { "name": "交易操盘手", "desc": "通过交易行获得翠玉交易数量≥5000" },
	                    { "name": "副本劳模", "desc": "衡道书副本通关次数≥100次" }
	                ]
	            }
	        },
	        "session_id": "G7lbC3TORB705BQMUYltWucLXqBoujLtkcQUil3n",
	        "request_id": "04a2ca585948406e42b1f5ec39c9d787666f8764"
	    }
	 }
		*/
  service.getReview = function(_mock_passport_account) {
    return request
      .jsonp(rootAddress + '/jxsjmobile4/team260804/get_review', {
        _mock_passport_account: _mock_passport_account /*  通行证（模拟登录，测试环境使用） */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": {
            "review_data": "老玩家回顾数据（本期 Mock，字段对齐大数据字段表）"
          },
          "data{}.review_data{}": {
            "account_id": "老玩家账号ID",
            "baihutang_cnt": "白虎堂参与次数",
            "baitan_cuiyu": "摆摊翠玉数量（交易统计）",
            "baitan_yuanbao": "摆摊元宝数量（交易统计）",
            "disciple_names": "得意弟子名称列表（收徒记录）",
            "first_hit_count": "家族首刀次数（三才首领+秦始皇陵）",
            "first_login_date": "首次登录日期（Y-m-d）",
            "fudai_cnt": "福袋开启次数",
            "hengdaoshu_cnt": "横刀书参与次数",
            "hengdaoshu_time": "横刀书累计时长（分钟）",
            "is_baobei": "是否家族宝贝（0：否，1：是）",
            "is_fuzuzhang": "是否副族长（0：否，1：是）",
            "is_zhanglao": "是否长老（0：否，1：是）",
            "is_zuzhang": "是否族长（0：否，1：是）",
            "jianxia_score": "剑侠分（最终综合评分）",
            "last_hit_count": "家族尾刀次数（三才首领+秦始皇陵）",
            "linan_cnt": "临安占领次数（领土战+逐鹿）",
            "lingtu_cnt": "领土占领次数",
            "master_date": "拜师纪念日期（Y-m-d，取最早拜师记录）",
            "master_name": "师父名称（取最早拜师记录）",
            "p2p_cnt": "P2P交易次数（交易统计）",
            "partner_date": "侠侣结缘纪念日期（Y-m-d，取最新结缘记录）",
            "partner_name": "侠侣名称（取最新结缘记录）",
            "role_body_type": "体型编号（1：成男）",
            "role_gender": "角色性别",
            "role_id": "主角色（游玩时间最久）角色ID",
            "role_level": "角色等级",
            "role_menpai_id": "门派ID",
            "role_menpai_name": "门派名称",
            "role_name": "主角色角色名称",
            "role_online_time": "累计在线时长（分钟）",
            "songjin_cnt": "宋金战场参与次数",
            "tag_list": "玩家标签列表（标签判定值为1的转中文输出）",
            "tianxia_cnt": "逐鹿占领次数",
            "tong_days": "加入家族天数",
            "tong_id": "家族ID",
            "tong_name": "家族名称",
            "tong_position_list": "家族职位列表（英文逗号分隔）"
          }
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20141",
        "description": "仅老玩家可参与回顾"
      }]
      		*/
        return reject(response);
      });
  };
  /**
		标记回顾完成
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/team260804/finish_review?_mock_passport_account=12231233333

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "G7lbC3TORB705BQMUYltWucLXqBoujLtkcQUil3n",
	        "request_id": "858b1d0602998ba79488bece1a7b6e1666103611"
	    }
	 }
		*/
  service.finishReview = function(_mock_passport_account) {
    return request
      .jsonp(rootAddress + '/jxsjmobile4/team260804/finish_review', {
        _mock_passport_account: _mock_passport_account /*  通行证（模拟登录，测试环境使用） */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": []
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20141",
        "description": "仅老玩家可参与回顾"
      }]
      		*/
        return reject(response);
      });
  };
  /**
		首次分享海报触发外观奖励
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/team260804/claim_share_prize?_mock_passport_account=12231233333&qrcode_type=home

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "...",
	        "request_id": "..."
	    }
	 }
		*/
  service.claimSharePrize = function(_mock_passport_account, qrcode_type) {
    return request
      .jsonp(rootAddress + '/jxsjmobile4/team260804/claim_share_prize', {
        _mock_passport_account: _mock_passport_account /*  通行证（模拟登录，测试环境使用） */,
        qrcode_type: qrcode_type /*  二维码类型（team/home/download，可选） */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": []
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20129",
        "description": "该账号未组队"
      }]
      		*/
        return reject(response);
      });
  };
  /**
		海报基础信息
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/team260804/get_poster?_mock_passport_account=12231233333

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "register_date": "2026-08-01",
	        "tag_list": {
	            "3": [
	                { "name": "风流才子", "desc": "曾结交≥2个情缘" },
	                { "name": "桃李满天下", "desc": "≥5位徒弟成功出师" },
	                { "name": "外观收藏家", "desc": "历史曾经激活20个以上外观" }
	            ],
	            "2": [
	                { "name": "胜友如云", "desc": "社交好友数量≥100个" },
	                { "name": "百战不屈", "desc": "死亡记录≥1000次" },
	                { "name": "凌绝顶", "desc": "历史自然月末排名战力榜前10" }
	            ],
	            "1": [
	                { "name": "家族脊梁", "desc": "曾经担任过普通成员外的职位" },
	                { "name": "交易操盘手", "desc": "通过交易行获得翠玉交易数量≥5000" },
	                { "name": "副本劳模", "desc": "衡道书副本通关次数≥100次" }
	            ]
	        },
	        "invite_params": {
	            "share_code": "9f2b6204be8c73289926979819c86415",
	            "team_id": ""
	        },
	        "menpai_id": "3",
	        "body_type": "1",
	        "download_url": "",
	        "session_id": "G7lbC3TORB705BQMUYltWucLXqBoujLtkcQUil3n",
	        "request_id": "e34576c5423d172b841afbe733b0ed24557c5d9e"
	    }
	 }
		*/
  service.getPoster = function(_mock_passport_account) {
    return request
      .jsonp(rootAddress + '/jxsjmobile4/team260804/get_poster', {
        _mock_passport_account: _mock_passport_account /*  通行证（模拟登录，测试环境使用） */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": {
            "body_type": "体类型(有1-成男、2-成女、3-少女、4-少年)",
            "download_url": "下载URL",
            "invite_params": "邀请参数",
            "menpai_id": "门派ID",
            "register_date": "注册日期",
            "tag_list": "按稀有度分组（键3/2/1，3最高）的标签对象数组，每项 {name, desc}，desc 为达成条件描述（2026-09-21 实测）"
          },
          "data{}.invite_params{}": {
            "share_code": "个人分享码（用于生成海报/邀请链接及回流识别，未登录返回空字符串）",
            "team_id": "队伍id"
          }
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }]
      		*/
        return reject(response);
      });
  };
  /**
		可召回好友列表
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/team260804/get_recall_list?_mock_passport_account=12231233333

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "recall_list": [
	            {
	                "relation_type": "jieyuan_role_name",
	                "relation": "侠侣",
	                "role_name": "月下听雪",
	                "has_sent_sms": 0
	            },
	            {
	                "relation_type": "shifu_role_name",
	                "relation": "师傅",
	                "role_name": "一剑霜寒",
	                "has_sent_sms": 0
	            },
	            {
	                "relation_type": "tudi_role_name1",
	                "relation": "徒弟",
	                "role_name": "青衫客",
	                "has_sent_sms": 0
	            },
	            {
	                "relation_type": "tudi_role_name2",
	                "relation": "徒弟",
	                "role_name": "白衣渡",
	                "has_sent_sms": 0
	            },
	            {
	                "relation_type": "tudi_role_name3",
	                "relation": "徒弟",
	                "role_name": "醉清风",
	                "has_sent_sms": 0
	            }
	        ],
	        "session_id": "G7lbC3TORB705BQMUYltWucLXqBoujLtkcQUil3n",
	        "request_id": "9b133502a7f7f2949fff8bdac10e45bbc5920fc9"
	    }
	 }
		*/
  service.getRecallList = function(_mock_passport_account) {
    return request
      .jsonp(rootAddress + '/jxsjmobile4/team260804/get_recall_list', {
        _mock_passport_account: _mock_passport_account /*  通行证（模拟登录，测试环境使用） */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": {
            "recall_list": "可召回好友列表"
          },
          "data{}.recall_list[]": {
            "has_sent_sms": "是否发送短信（0-未发送，1-已发送）",
            "relation": "关系",
            "relation_type": "关系类型",
            "role_name": "角色名称"
          }
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20142",
        "description": "暂无可召回好友列表"
      }]
      		*/
        return reject(response);
      });
  };
  /**
		好友召回（发送召回短信）
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/team260804/recall_friend?_mock_passport_account=12231233333&relation_type=jieyuan_role_name

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "G7lbC3TORB705BQMUYltWucLXqBoujLtkcQUil3n",
	        "request_id": "2e2079cf63f853d157064dfb59d6290a45baa8cc"
	    }
	 }
		*/
  service.recallFriend = function(_mock_passport_account, relation_type) {
    return request
      .jsonp(rootAddress + '/jxsjmobile4/team260804/recall_friend', {
        _mock_passport_account: _mock_passport_account /*  通行证（模拟登录，测试环境使用） */,
        relation_type: relation_type /*  关系标识，取自 get_recall_list 返回的 relation_type（结缘 jieyuan_role_name / 师父 shifu_role_name / 徒弟 tudi_role_name1-3） */
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          /**
        {
          "data{}": []
        }
        		*/
          return response.data;
        }
        /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20143",
        "description": "请选择要召回的好友"
      }, {
        "code": "-20144",
        "description": "仅老玩家可发起好友召回"
      }, {
        "code": "-20148",
        "description": "该好友关系不存在"
      }, {
        "code": "-20150",
        "description": "该好友已发送过召回短信"
      }]
      		*/
        return reject(response);
      });
  };
  return service;
}
